import React from 'react';
import style from './style.scss';

class BusinessNotification extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="item-business-notif">
        <div className='item-business-notif-left-time'>
          <p className='item-business-notif-time'>9:24</p>
          <p className='item-business-notif-day'>10/09/2017</p>
        </div>
        <p className='item-business-notif-right-desc'>Sed a turpis placerat felis vulputate varius. Nam nec urna a tellus volutpat efficitur quis finibus quam...
          <a className='view-detail' href=''>xem chi tiết</a>
        </p>
      </div>
    );
  }
}

export default BusinessNotification;


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/notification/BusinessNotificationItem.jsx